const t = "styles-module__gradientButton___9sybz", e = "styles-module__isScrolled___6-ubi", s = "styles-module__gradientButtonLabel___ukAYj", n = "styles-module__isOpen___EzxPA", _ = {
  gradientButton: t,
  isScrolled: e,
  gradientButtonLabel: s,
  isOpen: n
};
export {
  _ as default,
  t as gradientButton,
  s as gradientButtonLabel,
  n as isOpen,
  e as isScrolled
};
